//summary of everything
import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
/*
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {apiUrl} from '../../../util/Api';
*/
import { Bar, Pie} from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, LineElement, PointElement, LinearScale, BarElement, CategoryScale, Title, Tooltip, Legend } from 'chart.js';
import { getFactDateRange, getColor,getColors, toDisplayDate, roundNum, } from '../../../util/ChartUtils';

ChartJS.register(ArcElement, Tooltip, Legend);

const ModelCharts = (props) => {

    let detailData = props.data;
    let range = props.range;

    let dateRange = getFactDateRange(range.startDate, range.endDate)

    if (dateRange.length > detailData.length) {
        //have missing periods that need to be fixed
        for (let i = 0; i < dateRange.length; i++) {
            if (i >= detailData.length || dateRange[i].factDate != detailData[i].factDate) {
                detailData.splice(i, 0, { factDate: dateRange[i].factDate })
            }
        }
    }

    const InteractionPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        let labels = ['prompts', 'responses'];
        let prompts = 0;
        let responses = 0;
        let interactions = 0; 
        data.forEach((item, i) => {
            prompts += item?.promptsIn ? item.promptsIn : 0;
            responses += item?.responsesOut ? item.responsesOut : 0;
            interactions += item?.interactions ? item.interactions : 0;
        });

        let metrics = [prompts, responses];
        let colors = getColors(labels.length);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{interactions} Interactions</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                //label: 'tokens',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        }
                    }
                }} />
            </div>
        )


    }
    
    const InteractionBarChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        //resort by date - don't allow chart to reorder
        data.sort((a, b) => (a.factDate > b.factDate) ? 1 : -1)
        let prompts = [];
        let responses = [];
        let interactions = 0; 
        let labels = []
        data.forEach((item, i) => {
            labels.push(toDisplayDate(item.factDate));
            prompts.push(item.promptsIn);
            responses.push(item.responsesOut);
            interactions += item?.interactions ? item.interactions : 0;
        });

        return (
            <div className='chart-card'>
                {/*<div className='chart-title'>{totalTokens} Total Tokens</div>*/}
                
                <Bar data={
                    {
                        labels: labels, 
                        datasets: [
                            { label: 'Prompts', data: prompts, yAxisID: 'y', backgroundColor: getColor(1), borderColor: getColor(1) },
                            { label: 'Responses', data: responses, yAxisID: 'y', backgroundColor: getColor(2), borderColor: getColor(2) },
                        ]
                    }}
                    options={
                        { 
                            legend: { display: true, position: 'top' }, 
                            scales: { 
                                y: { 
                                    suggestedMin: 0 ,
                                    border:{dash: [3, 3], color:'#dedede'},
                                    grid: {
                                        color: '#e3e3e3',
                                    }
                                    
                                }, 
                                x: {
                                    border:{dash: [3, 3], color:'#dedede'},
                                    grid: {
                                        color: '#e3e3e3',
                                    }
                                }
                            },
                            plugins : {
                                legend : {
                                    labels : {
                                        usePointStyle : true, 
                                        boxHeight: 8
                                    }, 
                                    align:'end',
                                    
                                }
                            } 
                        }
                    } />

            </div>
        )

    }

    
    
    const TokenPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        let labels = ['prompt tokens', 'completion tokens'];
        let promptTokens = 0;
        let completionTokens = 0;
        let totalTokens = 0; 
        data.forEach((item, i) => {
            promptTokens += item?.promptTokens ? item.promptTokens : 0;
            completionTokens += item?.completionTokens ? item.completionTokens : 0;
            totalTokens += item?.totalTokens ? item.totalTokens : 0;
        });
        /*
        let promptTokens = data.reduce((temp, elem) => (
            temp + elem.promptTokens
        ), 0)
        let completionTokens = data.reduce((temp, elem) => (
            temp + elem.completionTokens
        ), 0)
        let total = data.reduce((temp, elem) => (
            temp + elem.totalTokens
        ), 0)
        */
        let metrics = [promptTokens, completionTokens];
        let colors = getColors(labels.length);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{totalTokens} Total Tokens</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'tokens',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        }
                    }
                }} />
            </div>
        )

    }
    const TokenBarChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        data.sort((a, b) => (a.factDate > b.factDate) ? 1 : -1) 
        let promptTokens = [];
        let completionTokens = [];
        let totalTokens = 0; 
        let labels = []
        data.forEach((item, i) => {
            labels.push(toDisplayDate(item.factDate));
            promptTokens.push(item.promptTokens);
            completionTokens.push(item.completionTokens);
            totalTokens += item?.totalTokens ? item.totalTokens : 0;
        });

        return (
            <div className='chart-card'>
                {/*<div className='chart-title'>{totalTokens} Total Tokens</div>*/}
                
                <Bar data={
                    {
                        labels: labels, 
                        datasets: [
                            { label: 'Prompt Tokens', data: promptTokens, yAxisID: 'y', backgroundColor: getColor(1), borderColor: getColor(1) },
                            { label: 'Completion Tokens', data: completionTokens, yAxisID: 'y', backgroundColor: getColor(2), borderColor: getColor(2) },
                        ]
                    }}
                    options={
                        { 
                            legend: { display: true, position: 'top' }, 
                            scales: { 
                                y: { 
                                    suggestedMin: 0 ,
                                    border:{dash: [3, 3], color:'#dedede'},
                                    grid: {
                                        color: '#e3e3e3',
                                    }
                                    
                                }, 
                                x: {
                                    border:{dash: [3, 3], color:'#dedede'},
                                    grid: {
                                        color: '#e3e3e3',
                                    }
                                }
                            },
                            plugins : {
                                legend : {
                                    labels : {
                                        usePointStyle : true, 
                                        boxHeight: 8
                                    }, 
                                    align:'end',
                                    
                                }
                            } 
                        }
                    } />

            </div>
        )

    }
    
    const CostChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        data.sort((a, b) => (a.factDate > b.factDate) ? 1 : -1) 
        let costs = [];
        let totalCost = 0; 
        let labels = []
        data.forEach((item, i) => {
            labels.push(toDisplayDate(item.factDate));
            costs.push(item.totalCost);
            totalCost += item?.totalCost ? item.totalCost : 0;
        });

        return (
            <div className='chart-card'>
                <div className='chart-title'>${roundNum(totalCost,6)} Total Cost</div>
                
                <Bar data={
                    {
                        labels: labels, 
                        datasets: [
                            { label: 'Cost', data: costs, yAxisID: 'y', backgroundColor: getColor(1), borderColor: getColor(1) },
                        ]
                    }}
                    options={
                        { 
                            legend: { display: true, position: 'top' }, 
                            scales: { 
                                y: { 
                                    suggestedMin: 0 ,
                                    border:{dash: [3, 3], color:'#dedede'},
                                    grid: {
                                        color: '#e3e3e3',
                                    }
                                    
                                }, 
                                x: {
                                    border:{dash: [3, 3], color:'#dedede'},
                                    grid: {
                                        color: '#e3e3e3',
                                    }
                                }
                            },
                            plugins : {
                                legend : {
                                    labels : {
                                        usePointStyle : true, 
                                        boxHeight: 8
                                    }, 
                                    align:'end',
                                    
                                },
                                tooltip: {
                                    callbacks: {
                                        label: (ctx) => {
                                            return ctx.dataset.label + ': ' + roundNum(ctx.parsed.y,6)
                                        }
                                    }
                                }
                            } 
                        }
                    } />

            </div>
        )

    }

    const LatencyChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        data.sort((a, b) => (a.factDate > b.factDate) ? 1 : -1) 
        let latency = [];
        let latencySum = 0; 
        let interactions = 0;
        let avgLatency = 0;
        let labels = []
        data.forEach((item, i) => {
            labels.push(toDisplayDate(item.factDate));
            latency.push(item.avgLatency);
            latencySum += item?.latency ? item.latency : 0;
            interactions += item?.interactions ? item.interactions : 0;
        });
        if(interactions > 0) {
            avgLatency = latencySum/interactions;
        }

        return (
            <div className='chart-card'>
                <div className='chart-title'>{roundNum(avgLatency,0)} Average Latency</div>
                
                <Bar data={
                    {
                        labels: labels, 
                        datasets: [
                            { label: 'Average Latency', data: latency, yAxisID: 'y', backgroundColor: getColor(1), borderColor: getColor(1) },
                        ]
                    }}
                    options={
                        { 
                            legend: { display: true, position: 'top' }, 
                            scales: { 
                                y: { 
                                    suggestedMin: 0 ,
                                    border:{dash: [3, 3], color:'#dedede'},
                                    grid: {
                                        color: '#e3e3e3',
                                    }
                                    
                                }, 
                                x: {
                                    border:{dash: [3, 3], color:'#dedede'},
                                    grid: {
                                        color: '#e3e3e3',
                                    }
                                }
                            },
                            plugins : {
                                legend : {
                                    labels : {
                                        usePointStyle : true, 
                                        boxHeight: 8
                                    }, 
                                    align:'end',
                                    
                                },
                                tooltip: {
                                    callbacks: {
                                        label: (ctx) => {
                                            return ctx.dataset.label + ': ' + roundNum(ctx.parsed.y,0)
                                        }
                                    }
                                }
                            } 
                        }
                    } />

            </div>
        )

    }

    
    return (
            <>
                {/*
                    errors.length > 0 ? (
                        <Alert variant='danger'>
                            {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                        </Alert>
                    ) : (null)
                */}
                {
                    (Array.isArray(detailData) && detailData.length > 0) ? (
                        <>
                            
                            <Row >
                                <Col md={4} lg={4} className='mb-5'>
                                    <TokenPieChart data={detailData}/>
                                </Col>
                                <Col md={8} lg={8} className='mb-5'>
                                    <TokenBarChart data={detailData}/>
                                </Col>
                            </Row>
    
                            <Row>
                                <Col md={4} lg={4} className='mb-5'>
                                    <InteractionPieChart data={detailData}/>
                                </Col>
                                <Col md={8} lg={8} className='mb-5'>
                                    <InteractionBarChart data={detailData}/>
                                </Col>
                            </Row>
                            
                            <Row md={2} lg={2}>
                                <Col className='mb-5'>
                                    <CostChart data={detailData}/> 
                                </Col>
                                <Col className='mb-5'>
                                <LatencyChart data={detailData}/>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        null
                    )
                }
        </>
    )
}

export default ModelCharts